<script setup>
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';

const props = defineProps({
  src: {
    required: true,
    type: String,
  },
  src2: {
    required: true,
    type: String,
  },
  alt: {
    required: false,
    type: String,
    default: '',
  },
  imgClass: {
    required: false,
    type: String,
    default: '',
  },
  start: {
    required: false,
    type: String,
    default: '0',
  },
  startMobile: {
    required: false,
    type: String,
    default: '0',
  },
});

const wrapperRef = ref();

const imgOne = ref();
const imgTwo = ref();

let tl;
onMounted(() => {
  gsap.set(imgTwo.value, { opacity: 0 });

  tl = gsap.timeline({
    scrollTrigger: {
      trigger: wrapperRef.value,
      start:
        window.innerWidth > 1024
          ? `top+=${props.start} top`
          : `top+=${props.startMobile} top`,
      end:
        window.innerWidth > 1024
          ? `top+=${+props.start + 100} top`
          : `top+=${+props.startMobile + 100} top`,
      pinSpacing: true,
      onEnter: () => tl.play(),
      onLeaveBack: () => tl.reverse(),
    },
  });
  tl.to(imgOne.value, { opacity: 0, duration: 2 }).fromTo(
    imgTwo.value,
    { opacity: 0 },
    { opacity: 1, duration: 2 },
    '<',
  );
});
</script>

<template>
  <div
    ref="wrapperRef"
    class="-z-10 overflow-hidden h-[700px] relative xl:h-[1085px] 2xl:h-[1364px] xl:overflow-visible -mt-5 xl:-mt-15 shadow-y select-none"
  >
    <img
      ref="imgOne"
      :src="src"
      :alt="alt"
      class="w-full object-cover absolute lg:static h-[780px] lg:h-full xl:absolute"
      :class="imgClass"
      loading="lazy"
      width="2560"
      height="1920"
    />
    <img
      ref="imgTwo"
      :src="`${src2}`"
      :alt="alt"
      class="w-full object-cover absolute lg:static h-[780px] lg:h-full xl:absolute"
      :class="imgClass"
      loading="lazy"
      width="2560"
      height="1920"
    />
  </div>
</template>
